module.exports = __webpack_public_path__ + "img/collection-weddingRingsWhitegold@2x.1274812.jpg";